import { render, staticRenderFns } from "./pto.vue?vue&type=template&id=33c16f13&scoped=true"
import script from "./pto.vue?vue&type=script&lang=js"
export * from "./pto.vue?vue&type=script&lang=js"
import style0 from "./pto.vue?vue&type=style&index=0&id=33c16f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c16f13",
  null
  
)

export default component.exports